// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__pS9Fg","summary":"CartItem_summary__nir6d","price":"CartItem_price__W8H1Y","amount":"CartItem_amount__98WCg","actions":"CartItem_actions__f-9Nq"};